import  router from '@/router/index';
import config from '@/config/prod.env';
import { authenticationService } from '@/services/authentication/authentication.service.js';

export const header = {
    authHeaderNoToken,
    authHeaderWithToken,
    authHeaderWithTokenFormData
};

async function authHeaderNoToken() {
    return await { 'Content-Type': 'application/json'};
}

async function authHeaderWithToken() {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.accessToken && Date.parse(user.expiresTime) > Date.now()) {
        return await { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.accessToken
        };
    }
    else {
        localStorage.removeItem('user');
        localStorage.removeItem('menu');
        //router.push({ path: '/login' });
        window.location.href = `${config.LOGIN_PAGE}#/login?appId=${config.APPID}`;
    }
}

async function authHeaderWithTokenFormData() {
    let user = JSON.parse(localStorage.getItem('user'));
    if (user && user.accessToken && Date.parse(user.expiresTime) > Date.now()) {
        return await { 'Authorization': 'Bearer ' + user.accessToken };
    }
    else {
        // Phiên đăng nhập hết hạn. Kiểm tra nếu có ghi nhớ đăng nhập thì Refresh lại token, còn không thì phải đăng nhập lại
        localStorage.removeItem('user');
        localStorage.removeItem('menu');
        //router.push({ path: '/login' });
        window.location.href = `${config.LOGIN_PAGE}#/login?appId=${config.APPID}`;
    }
}
